import Axios from "axios";

var LoginServiceMixin = {
    methods: {
        postLogin(data, captchaToken) {
            const config = { withCredentials: true };
            if (captchaToken) {
                config.headers = { "X-Captcha-Token": captchaToken };
            }
            return Axios.post(this.CriarUrl({ resource: "api/token" }), data, config);
        },

        getTermoAtivo() {
            return Axios.get(this.CriarUrl({ resource: "api/termo-usos/ativo" }), { withCredentials: true });
        },

        postLogout() {
            return Axios.post(this.CriarUrl({ resource: "api/logout" }), null, { withCredentials: true });
        }
    }
};

export default LoginServiceMixin;
